import { useState } from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Filters = ({ categories, authors, onFilterChange, category, author, search, updateFilter }) => {

    const [active, setActive] = useState("0");
    const handleFilterChange = (event) => {
        onFilterChange(event.target.name, event.target.value)
    }
    const handleCategoryClick = (event) => {
        event.preventDefault()
        updateFilter('blog-filters__category', event.target.getAttribute('data-category'))
        setActive(event.target.getAttribute('data-active-category'))
    }
    var settings = {
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick",
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 3,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    swipeToSlide: true,
                },
            },
        ]
    };
    return (
        <div className="blog-filter">
            <div id="blog-filters-category" className="category-field">
                <select aria-labelledby="blog-filters-category" className="form-select test-dropdown" name="blog-filters__category" onChange={handleFilterChange}
                        value={category}>
                    <option value="">All categories</option>
                    {categories.map((category) => {
                        return <option key={category.id} value={category.id} dangerouslySetInnerHTML={{ __html: category.name  }}></option>
                    })}
                </select>
                <div aria-labelledby="blog-filters-category" className="category-pills-list test-pills" name="blog-filters__category">
                    <Slider {...settings}>
                        <span className={active === String(0) ? 'category active' : 'category'} onClick={ handleCategoryClick } data-category="" data-active-category="0">All</span>
                        {categories.map((category) => {
                            return <span className={active === String(category.id) ? 'category active' : 'category'} onClick={ handleCategoryClick } data-category={category.id} data-active-category={category.id}>{ category.name }</span>
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )

}

export default Filters